import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["deleteButton"];

  deleteGA() {
    const gaIntegrationId = this.deleteButtonTarget.dataset.gaIntegrationId;
    const alert_message =
      "WARNING: Removing this integration will disable data streaming to your Google Analytics 4 property.<a href='https://support.google.com/analytics/answer/9973999?sjid=3738756760256590564-NC#add-remove' target='_blank'> Click here to learn more about removing a connected site tag.</a>";
    const dialog = $(
      `<div id='dialog-confirm' role='alert'><p>${alert_message}</p></div>`
    );
    const redirectToIntegrations = window.location.href.includes("google_analytics_reports");

    if (!$("#dialog-confirm").length) $("body").append(dialog);

    $('.reveal-modal-bg').css('z-index', 100);

    dialog.dialog({
      dialogClass: "ga-delete-confirmation-modal",
      resizable: false,
      draggable: false,
      modal: true,
      title: "Remove Google Analytics",
      buttons: {
        Cancel: {
          text: "Cancel",
          click: function () {
            $(this).dialog("close");
          },
        },
        Delete: {
          text: "Remove",
          click: function () {
            $(this).dialog("close");
            $('.google-analytics-modal')[0].removeAttribute("data-controller")
            window.modal.dirty = false;
          },
          "data-url": `/integrations/${gaIntegrationId}?redirect_to_integrations=${redirectToIntegrations}`,
          "data-method": "DELETE",
          "data-remote": "true",
        },
      },
    });
  }
}
